module.exports = __webpack_public_path__ + "assets/img/3-2-en.818a6e59.png";